export default {
  // ShareModal - Share Modal
  shareModalTitle: 'Share {{petName}}\'s Care Information',
  shareModalSubtitle: 'Select information types to share and generate a secure link',
  close: 'Close',
  
  // ShareModal - Enable Sharing
  enableSharingFeature: 'Enable Sharing Feature',
  sharingPrivacyNotice: 'You are about to enable sharing for "{{petName}}". This will generate a secure sharing link that allows you to share pet information with caregivers.',
  sharingFeatures: 'Sharing Features',
  uniqueSecureLink: 'Unique secure link',
  selectableInfoTypes: 'Selectable information types',
  disableAnytime: 'Disable anytime',
  noPersonalInfoLeak: 'No personal information leak',
  notNow: 'Not Now',
  enabling: 'Enabling...',
  enableSharing: 'Enable Sharing',
  
  // ShareModal - Error Messages
  shareEnableError: 'Failed to enable sharing feature',
  shareDisableError: 'Failed to disable sharing feature',
  
  // ShareModal - Tabs
  shareSelectInfo: 'Select Info',
  shareVia: 'Share Via',
  
  // ShareModal - Select Info
  selectedItems: '{{count}} items selected',
  shareSelectAll: 'Select All',
  shareDeselectAll: 'Deselect All',
  
  // ShareModal - Share Options
  sharePhoto: 'Pet Photo',
  sharePhotoDesc: 'Share your pet\'s photo',
  shareBasicInfo: 'Basic Info',
  shareBasicInfoDesc: 'Includes name, breed, age, gender, etc.',
  shareDietaryInfo: 'Dietary Info',
  shareDietaryInfoDesc: 'Includes feeding schedule, preferences, and restrictions',
  shareBehaviorInfo: 'Behavior Info',
  shareBehaviorInfo: 'Includes temperament, likes, exercise needs, etc.',
  shareHealthInfo: 'Health Info',
  shareHealthInfoDesc: 'Includes medication schedule, vaccines, allergies',
  shareEmergencyContact: 'Emergency Contact',
  shareEmergencyContactDesc: 'Includes veterinarian contact and insurance info',
  shareSpecialNotes: 'Special Notes',
  shareSpecialNotesDesc: 'Any other important care notes',
  
  // ShareModal - Preview
  preview: 'Preview',
  previewDescription: 'Preview how the shared page will look before sharing',
  
  // ShareModal - Share Methods
  chooseShareMethod: 'Choose Sharing Method',
  shareViaEmail: 'Via Email',
  shareViaEmailDesc: 'Share using your email client',
  shareViaWhatsApp: 'Via WhatsApp',
  shareViaWhatsAppDesc: 'Share on WhatsApp',
  shareViaLine: 'Via LINE',
  shareViaLineDesc: 'Share on LINE',
  
  // ShareModal - Share Link
  shareableLink: 'Shareable Link',
  copyLink: 'Copy Link',
  copied: 'Copied',
  generating: 'Generating...',
  
  // ShareModal - Share Message Templates
  emailSubject: '{{petName}}\'s Care Information',
  emailBody: 'Hello!\n\nI\'d like to share {{petName}}\'s care information with you. Please click the link below to view:\n\n{{shareUrl}}\n\nThank you!',
  whatsappMessage: 'Hi! I\'d like to share {{petName}}\'s care information with you: {{shareUrl}}',
  lineMessage: '{{petName}}\'s Care Information',
  
  // ShareModal - Security Tips
  securityReminder: 'Security Reminder',
  shareOnlyWithTrusted: 'Please only share this link with trusted caregivers. You can disable sharing anytime.',
  
  // ShareModal - Disable Sharing
  disableSharing: 'Disable Sharing',
  processing: 'Processing...',
  confirmDisable: 'Confirm Disable',
  
  // DisableShareConfirmModal - Disable Share Confirmation
  disableSharingTitle: 'Disable Sharing Feature',
  disableSharingMessage: 'Are you sure you want to disable sharing for this pet?',
  shareLinksInvalid: 'All existing share links will be immediately invalidated',
  viewersLoseAccess: 'People with the link will no longer be able to view the data',
  cancel: 'Cancel',
  
  // DeleteConfirmModal - Delete Confirmation
  confirmDelete: 'Confirm Delete',
  cannotUndo: 'This action cannot be undone',
  deletePetData: 'Delete Pet Data',
  confirmDeletePetMessage: 'Are you sure you want to delete all data for "{{petName}}"?',
  willLoseAfterDelete: 'After deletion, you will lose:',
  allBasicData: 'All basic data and photos',
  healthRecordsAndVaccines: 'Health records and vaccine information',
  careInstructionsAndNotes: 'Care instructions and notes',
  uploadedPhotos: 'Uploaded photos',
  shareLinksWillExpire: 'All share links will expire',
  deleting: 'Deleting...',
  deleteWarningMessage: 'Please proceed with caution, deleted data cannot be recovered',
  unnamedPet: 'Unnamed Pet',
  
  // LogoutConfirmModal - Logout Confirmation
  confirmLogout: 'Confirm Logout',
  logoutConfirmMessage: 'Are you sure you want to logout? You will need to login again to access your pet data.',
  logout: 'Logout',
  loggingOut: 'Logging out...',
};